import "./sentry";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from '@sentry/react';
import AppCrashed from './components/AppCrashed';
import "./index.css";
import "./styles/panel-fixes.css";
import { syncConsentToWindow } from "./lib/consent";

// Sync consent to window before any analytics or Sentry initialization
syncConsentToWindow();

// Set icon version for cache-busting in development
if (import.meta.env.DEV) {
  (window as any).__ICON_VERSION__ = Date.now();
}

// Configure Plotly to use MathJax for LaTeX rendering
declare global {
  interface Window {
    PlotlyConfig?: any;
    MathJax?: any;
  }
}

// Set up MathJax configuration for Plotly
window.PlotlyConfig = window.PlotlyConfig || {};
window.PlotlyConfig.MathJaxConfig = 'local';

// Configure MathJax
window.MathJax = {
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
    processEscapes: true,
    processEnvironments: true
  },
  options: {
    ignoreHtmlClass: '.*|',
    processHtmlClass: 'arithmatex'
  }
};

// Load MathJax script
const script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js';
script.async = true;
document.head.appendChild(script);

// Ensure WebSocket singleton initializes on bootstrap
import "./ws/socket";

// Cache-busting build id (forces new asset hash)
// eslint-disable-next-line no-console
console.log("BUILD_ID","takehome-hotfix-v3");
// Analytics initialization moved to App.tsx and gated on consent

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={({ eventId }) => <AppCrashed eventId={eventId || undefined} />} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>
);

console.log("������ TAKEHOME_BUNDLE_V5_LOADED at", new Date().toISOString());
console.log('🚀 TAKEHOME_BUNDLE_V5_LOADED at', new Date().toISOString());

